import { motion } from 'framer-motion';
import logoZofia from '@/assets/logo-zofia.png';

interface LoaderProps {
  onComplete: () => void;
}

const Loader = ({ onComplete }: LoaderProps) => {
  return (
    <motion.div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-background"
      initial={{ opacity: 1 }}
      animate={{ opacity: 0 }}
      transition={{ duration: 0.3, delay: 0.7 }}
      onAnimationComplete={onComplete}
    >
      <div className="relative flex flex-col items-center gap-8">
        {/* Logo - 30% larger */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
        >
          <img 
            src={logoZofia} 
            alt="Zofia Digital Agency" 
            className="h-28 md:h-36 w-auto"
          />
        </motion.div>

        {/* Loading bar - progressive fill */}
        <div className="w-48 h-px bg-muted overflow-hidden">
          <motion.div
            className="h-full bg-gold origin-left"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{
              duration: 0.7,
              ease: 'easeOut',
            }}
          />
        </div>

        {/* Loading text */}
        <motion.p
          className="text-sm text-muted-foreground tracking-[0.3em] uppercase"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.1, duration: 0.2 }}
        >
          Loading
        </motion.p>
      </div>
    </motion.div>
  );
};

export default Loader;
